import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ar from './locales/ar.json'

/**
 * i18next setup. English is the source of truth: every key must exist there
 * first. Arabic can lag behind page-by-page (this is being translated in
 * phases) — a missing Arabic key falls back to English rather than showing
 * a raw key, so an untranslated page is still usable, just not yet in
 * Arabic.
 *
 * Reads localStorage directly rather than importing lib/language.ts, so
 * that module can import the i18n instance from here without a cycle.
 */
const STORAGE_KEY = 'language'
const stored = localStorage.getItem(STORAGE_KEY)
const initialLanguage = stored === 'ar' ? 'ar' : 'en'

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes.
  },
  returnNull: false,
})

export default i18n
